import { Component } from '@angular/core';

@Component({
  selector: 'app-unauthorized',
  templateUrl: './unauthorized.component.html',
  styleUrl: './unauthorized.component.scss'
})
export class UnauthorizedComponent {
  ngOnInit() {
    // let UserDetails = this.tokenService.getUserDetails();
    // if (UserDetails != null || UserDetails != undefined) {
    //   this.roleValue = UserDetails.Value;
    // }
  }

  backToDashboard() {
    // if (this.roleValue != 'Client') {
    //   this.router.navigate(["/dashboard"]);
    // }
    // else {
    //   this.router.navigate(["/lead/task-board/board"])
    // }
  }
}
